export default [

    // gestione subsidiaries
    {
        path: '/subsidiares',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'3', subMenuActive:'3', title: 'headers.subsidiaries-title'},
        components: {
            default: () => import(/* webpackChunkName: "security" */ './views/subsidiary-main'),
            'section-header': () => import(/* webpackChunkName: "security" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'subsidiary-list',
                meta: {keepAlive: true, title: 'headers.subsidiaries-title', mainMenuActive:'3', subMenuActive:'3'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/subsidiary-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'subsidiary-edit',
                meta: {keepAlive: false, title: 'headers.subsidiaries-edit-title', mainMenuActive:'3', subMenuActive:'3'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/subsidiary-edit')
                }
            }]
    },

    // gestione ruoli utente
    {
        path: '/roles',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'3', subMenuActive:'2', title: 'headers.roles-title'},
        components: {
            default: () => import(/* webpackChunkName: "security" */ './views/role-main'),
            'section-header': () => import(/* webpackChunkName: "security" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'role-list',
                meta: {keepAlive: true, title: 'headers.roles-title', mainMenuActive:'3', subMenuActive:'2'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/role-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'role-edit',
                meta: {keepAlive: false, title: 'headers.roles-edit-title', mainMenuActive:'3', subMenuActive:'2'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/role-edit')
                },
            }
        ]
    },

    // elenco utenti
    {
        path: '/operators',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'3', subMenuActive:'1', title: 'headers.operator-title'},
        components: {
            default: () => import(/* webpackChunkName: "security" */ './views/operator-main'),
            'section-header': () => import(/* webpackChunkName: "security" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'operator-list',
                meta: {keepAlive: true, title: 'headers.operator-title', mainMenuActive:'3', subMenuActive:'1'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/operator-list')
                }
            },
            {
                path: ':id',
                name: 'operator-detail',
                meta: {keepAlive: false, title: 'headers.operator-detail', mainMenuActive:'3', subMenuActive:'1'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/operator-detail')
                }
            },
            {
                path: 'new',
                name: 'operator-new',
                meta: {keepAlive: false, title: 'headers.operator-detail', mainMenuActive:'3', subMenuActive:'1'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/operator-new')
                }
            },
        ]
    },
    // autorizzazioni classe
    {
        path: '/class-authorization',
        name: 'class-authorizations',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'3', subMenuActive:'4', title: 'headers.class-authorization-title'},
        components: {
            default: () => import(/* webpackChunkName: "security" */ './views/class-authorization'),
            'section-header': () => import(/* webpackChunkName: "security" */ './components/section-header')
        },
    },

    // autorizzazioni proprietà
    {
        path: '/property-authorization',
        name: 'property-authorizations',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'3', subMenuActive:'5', title: 'headers.property-authorization-title'},
        components: {
            default: () => import(/* webpackChunkName: "security" */ './views/property-authorization'),
            'section-header': () => import(/* webpackChunkName: "security" */ './components/section-header')
        },
    },

    // template autorizzativi
    {
        path: '/property-permission-templates',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'3', subMenuActive:'6', title: 'headers.property-permission-template-title'},
        components: {
            default: () => import(/* webpackChunkName: "security" */ './views/property-permission-template-main'),
            'section-header': () => import(/* webpackChunkName: "security" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'property-permission-template-list',
                meta: {keepAlive: true, title: 'headers.property-permission-template-title', mainMenuActive:'3', subMenuActive:'6'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/property-permission-template-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'property-permission-template-edit',
                meta: {keepAlive: false, title: 'headers.property-permission-template-edit-title', mainMenuActive:'3', subMenuActive:'6'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/property-permission-template-edit')
                },
            }
        ]
    },

    // gestione channels
    {
        path: '/channels',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'3', subMenuActive:'7', title: 'headers.channel-title'},
        components: {
            default: () => import(/* webpackChunkName: "security" */ './views/channel-main'),
            'section-header': () => import(/* webpackChunkName: "security" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'channel-list',
                meta: {keepAlive: true, title: 'headers.channels-title', mainMenuActive:'3', subMenuActive:'7'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/channel-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'channel-edit',
                meta: {keepAlive: false, title: 'headers.channel-detail', mainMenuActive:'3', subMenuActive:'7'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/channel-detail')
                }
            },
            {
                path: 'new',
                name: 'channel-new',
                meta: {keepAlive: false, title: 'headers.channel-detail', mainMenuActive:'3', subMenuActive:'7'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/channel-new')
                }
            },
            {
                path: ':channelId/family/:familyId',
                name: 'channel-family',
                meta: {keepAlive: false, title: 'headers.channel-family', mainMenuActive:'3', subMenuActive:'7'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "security" */ './views/channel-family-detail')
                }
            },
            ]
    },

];
